<template lang="pug">
div
  v-card
    v-card-title.pb-0(style="wrap-text:nowrap") Reservation Allowances
    v-card-text.pb-0
      div(v-if="registrationGroup.timing_status == 'ON_TIME'") Last registration day {{registrationGroup.formatted_end_date}}
      div.red--text.text--darken-2(v-else-if="registrationGroup.timing_status == 'TOO_LATE'") Registration ended {{registrationGroup.formatted_end_date}}
      div.red--text.text--darken-2(v-else) Registration starts {{registrationGroup.formatted_start_date}}
    v-list(dense :style="isInTimingWindow  ? '' : 'opacity:0.5'")
      v-list-item(v-for="allowance in groupedAllowances" :key="allowance.slug")
        v-list-item-content
          .body-2
            span.font-weight-bold {{allowance.typeString}}&nbsp;
            span ({{allowance.count}}):&nbsp;
            v-chip(:color="allowance.color" dark) {{allowance.statusString}}
    p.body-2.pa-4.pt-0(v-if="allowances.length == 0") No registration allowances available.
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters([
      'allowanceUsage',
      'isInTimingWindow',
      'registrationGroup'
    ]),
    allowances() {
      let typeStrings = {
        weekday: "Weekday",
        weekend: "Weekend",
        either: "Weekday or Weekend"
      }
      let statusStrings = {
        free: "Available",
        reserved: "Reserved",
        pending: "Pending"
      }
      let colors = {
        free: "blue",
        reserved: "#2E7D32",
        pending: "#ce93d8"
      }
      let allowanceUsage = this.allowanceUsage
      return ['weekday', 'weekend', 'either'].map(key => {
        return allowanceUsage[key].map(status => ({
          typeString: typeStrings[key],
          type: key,
          statusString: statusStrings[status],
          status,
          color: colors[status]
        }))
      }).flat(1)
    },
    groupedAllowances() {
      return this.allowances.reduce((acc, allowance) => {
        let existing = acc.find(it => it.type == allowance.type && it.status == allowance.status)
        if(existing)
          existing.count++
        else
          acc.push({
            ...allowance,
            count: 1,
            slug: `${allowance.type}-${allowance.status}`
          })
        return acc
      }, [])
    },

  }
}
</script>